import flatten from 'flat'
import { version as versionNumber } from '../../package.json'

const isDev = process.env.NODE_ENV === 'development'

export const config = {
  // apiUrl: 'http://localhost:9001/flatastic-backend/index.php/api',
  // apiUrl: 'http://192.168.0.123:9001/flatastic-backend/index.php/api',
  apiUrl: 'https://dev.api.flatastic-app.com/index.php/api',
  defaultApiKey: 'publicKey',
  versionNumber: `${versionNumber}.1${isDev ? ` - DEVELOPMENT` : ``}`,
  senderId: '319060687536',
  debug: isDev,
}

export const localStorageKeys = {
  choreProposals: {
    hide: 'Flatastic.choreProposals.hide',
    data: 'Flatastic.choreProposals.data',
  },
  experiments: {
    settings: 'Flatastic.experiments',
    lastUpdate: 'Flatastic.experiments.lastUpdate',
  },
  user: {
    store: 'Flatastic.User',
    dataSent: 'Flatastic.User.dataSent',
  },
  notifications: {
    activities: 'Flatastic.Activities',
  },
  shoppinglist: {
    storage: 'Flatastic.Shoppinglist',
    itemDetailsDeferredAt: 'Flatastic.shoppinglist.details.deferredAt',
    quickEditDeferredAt: 'Flatastic.shoppinglist.quickEdit.deferredAt',
    quickEditInfoDismissed: 'Flatastic.shoppinglist.quickEdit.infoDismissed',
    tagsInfoDismissed: 'Flatastic.shoppinglist.tags.infoDismissed',
  },
  wg: {
    setup: 'Flatastic.wgSetupPending',
  },
  behavior: {
    lastUsedModule: 'Flatastic.lastUsedModule',
  },
}

export const eventNames = {
  badge: {
    update: 'Flatastic:Badge:update',
  },
  chores: {
    update: 'Flatastic:Chores:update',
    willCreate: 'chores:will-create',
    willComplete: 'chores:will-complete',
    didDeleteChore: 'Chore:deleted',
    didCreateChore: 'Flatastic:Chores:didCreate',
    didCompleteChore: 'Chore:done',
    didResetStatistics: 'Flatastic:Chores:didResetStatistics',
  },
  expenses: {
    update: 'Flatastic:Expenses:update',
    willCreate: 'expenses:will-create',
    didCreate: 'expenses:did-create',
    didResetBalance: 'Flatastic:Expenses:didResetBalance',
  },
  shoppinglist: {
    update: 'Flatastic:Shoppinglist:update',
    addItem: 'ShoppinglistItem:add',
    willCreate: 'ShoppinglistItem:will-create',
    deleteItem: 'ShoppinglistItem:deleted',
    saveItem: 'ShoppinglistItem:save',
    didAddItem: 'Flatastic:Shoppinglist:didAddItem',
    didCheckItem: 'Flatastic:Shoppinglist:didCheckItem',
    didRemoveBoughtItems: 'Flatastic:Shoppinglist:didRemoveBoughtItems',
  },
  shouts: {
    update: 'Flatastic:Shouts:update',
    didCreate: 'Flatastic:Shouts:didCreateShout',
    didDelete: 'Flatastic:Shouts:didDeleteShout',
    didLike: 'Flatastic:Shouts:didLikeShout',
    didUnlike: 'Flatastic:Shouts:didUnlikeShout',
  },
  subscriptions: {
    update: 'Flatastic:Subscriptions:update',
    didCreateEntry: 'Flatastic:Subscriptions:didCreateEntry',
    didDeleteEntry: 'Flatastic:Subscriptions:didDeleteEntry',
    didUpdateEntry: 'Flatastic:Subscriptions:didUpdateEntry',
  },
  user: {
    didLogout: 'FlatasticUser:logout',
    didEnterWg: 'Flatastic:UserEnteredWg',
    didLogin: 'FlatasticUser:loginSuccess',
    didRegister: 'FlatasticUser:registerSuccess',
    didLeaveWg: 'Flatastic:UserLeftWg',
    didGetPremium: 'FlatasticUser:DidGetPremium',
    didUpdate: 'FlatasticUser:DidUpdate',
  },
  wg: {
    didUpdate: 'Flatastic:Wg:update',
    didShareInvitationCode: 'Flatastic:Wg:DidShareInvitationCode',
    didNotInviteAnyoneElse: 'Flatastic:Wg:DidNotInviteAnyoneElse',
    someoneHasNotMovedInYet: 'Flatastic:Wg:SomeoneHasNotMovedInYet',
  },
}

export default angular.module('flatastic.config', [])

.run(['FlatasticEvents', '$rootScope', 'LocalStorageKeys', '$window', function(FlatasticEvents, $rootScope, LocalStorageKeys, $window) {
  $rootScope.$on(FlatasticEvents.user.didLogout, function() {
    Object.values(flatten(LocalStorageKeys)).forEach(key => delete $window.localStorage.removeItem(key))
  })
}])

.value('Config', config)

.value('FlatasticEvents', eventNames)

.value('LocalStorageKeys', localStorageKeys)

.name;
